<template>
  <div>
    <b-container>
      <b-row>
        <b-col>
            <!-- Name and Email Group -->
            <b-row class="mb-3">
                <b-input-group size="sm">
                    <b-input-group-prepend is-text>Nome:</b-input-group-prepend>
                    <b-form-input id="nome" type="text" name="nome" maxlength="100" v-model="form.ds_nome" placeholder="Digite o nome"></b-form-input>
                    
                    <b-input-group-prepend is-text>Sobrenome:</b-input-group-prepend>
                    <b-form-input id="sobrenome" type="text" name="sobrenome" maxlength="100" v-model="form.ds_sobrenome" placeholder="Digite o sobrenome"></b-form-input>

                    <b-input-group-prepend is-text>Email:</b-input-group-prepend>
                    <b-form-input id="email" type="text" name="email" maxlength="100" v-model="form.email" placeholder="Digite o sobrenome"></b-form-input>
                </b-input-group>
            </b-row>

            <!-- Contact Information Group -->
            <b-row class="mb-3">
                <b-input-group size="sm">
                    <b-input-group-prepend is-text>Celular DDD:</b-input-group-prepend>
                    <b-form-input id="ddd_celular" type="text" name="ddd_celular" maxlength="3" v-model="form.ddd_celular" placeholder="DDD"></b-form-input>
                    
                    <b-input-group-prepend is-text>Celular:</b-input-group-prepend>
                    <b-form-input id="celular" type="text" name="celular" maxlength="10" v-model="form.celular" placeholder="Celular"></b-form-input>
                    
                    <b-input-group-prepend is-text>Telefone DDD:</b-input-group-prepend>
                    <b-form-input id="ds_ddd_telefone" type="text" name="ds_ddd_telefone" maxlength="3" v-model="form.ds_ddd_telefone" placeholder="DDD"></b-form-input>
                    
                    <b-input-group-prepend is-text>Telefone:</b-input-group-prepend>
                    <b-form-input id="ds_telefone" type="text" name="ds_telefone" maxlength="10" v-model="form.ds_telefone" placeholder="Telefone"></b-form-input>
                </b-input-group>
            </b-row>

            <!-- Personal Identification Group -->
            <b-row class="mb-3">
                <b-input-group size="sm">
                    <b-input-group-prepend is-text>Data de Nascimento:</b-input-group-prepend>
                    <b-form-input 
                        id="dt_nascimento" 
                        type="text" 
                        name="dt_nascimento" 
                        v-model="form.dt_nascimento" 
                        v-mask="'##/##/####'"
                        placeholder="DD/MM/YYYY">
                    </b-form-input>

                    <b-input-group-prepend is-text>CPF:</b-input-group-prepend>
                    <b-form-input id="cd_cpf" type="text" name="cd_cpf" maxlength="11" v-model="form.cd_cpf" placeholder="CPF"></b-form-input>

                    <b-input-group-prepend is-text>RG:</b-input-group-prepend>
                    <b-form-input id="cd_rg" type="text" name="cd_rg" maxlength="9" v-model="form.cd_rg" placeholder="RG"></b-form-input>
                </b-input-group>
            </b-row>

            <!-- Address Group -->
            <b-row class="mb-3">
                <b-input-group size="sm">
                    <b-input-group-prepend is-text>Endereço:</b-input-group-prepend>
                    <b-form-input id="ds_endereco" type="text" name="ds_endereco" maxlength="100" v-model="form.ds_endereco" placeholder="Endereço"></b-form-input>

                    <b-input-group-prepend is-text>Número:</b-input-group-prepend>
                    <b-form-input id="nr_endereco" type="text" name="nr_endereco" maxlength="10" v-model="form.nr_endereco" placeholder="Número"></b-form-input>

                    <b-input-group-prepend is-text>Complemento:</b-input-group-prepend>
                    <b-form-input id="ds_compl_endereco" type="text" name="ds_compl_endereco" maxlength="50" v-model="form.ds_compl_endereco" placeholder="Complemento"></b-form-input>

                    <b-input-group-prepend is-text>Bairro:</b-input-group-prepend>
                    <b-form-input id="ds_bairro" type="text" name="ds_bairro" maxlength="50" v-model="form.ds_bairro" placeholder="Bairro"></b-form-input>
                </b-input-group>
            </b-row>

            <!-- Additional Information Group -->
            <b-row class="mb-3">
                <b-input-group size="sm">
                    <b-input-group-prepend is-text>Cidade:</b-input-group-prepend>
                    <b-form-input id="ds_cidade" type="text" name="ds_cidade" maxlength="50" v-model="form.ds_cidade" placeholder="Cidade"></b-form-input>

                    <b-input-group-prepend is-text>CEP:</b-input-group-prepend>
                    <b-form-input id="cd_cep" type="text" name="cd_cep" maxlength="8" v-model="form.cd_cep" placeholder="CEP"></b-form-input>

                    <b-input-group-prepend is-text>Estado:</b-input-group-prepend>
                    <b-form-select v-model="form.id_estado" :options="selects.state" size="sm" />
                </b-input-group>
            </b-row>

            <!-- Subscription Preferences Group -->
            <b-row class="mb-3">
              <b-input-group size="sm">
                <b-form-checkbox v-model="receivesInfo">
                  Receber Informações
                </b-form-checkbox>

                <b-form-checkbox v-model="receivesSms">
                  Receber SMS
                </b-form-checkbox>

                <b-form-checkbox v-model="agreesToTerms">
                  Concordo com os Termos
                </b-form-checkbox>

                <b-form-checkbox v-model="is_disabled">
                  Inativar Cadastro
                </b-form-checkbox>
              </b-input-group>
            </b-row>

            <!-- Save Button -->
            <b-row class="mb-3">
                <b-button type="button" variant="success" size="sm" @click="save">
                    <span v-if="!processing">Salvar</span>
                </b-button>
            </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Vue from "vue";
import VueHead from 'vue-head';
import VueMask from 'v-mask';
import config from "@/config";
import Password from 'vue-password-strength-meter';
import { func } from "@/functions";
import { clientService } from '../../components/common/services/client';
import { stateService } from '../../components/common/services/state';

Vue.use(VueHead);
Vue.use(VueMask);

export default {
  mixins: [func],
  props: ['id'],
  components: { Password },
  name: 'client-add',
  head: {
    title: function () {
      return { 
        inner: `TicketOffice | Admin`,
        separator: " | ",
        complement: `Cliente - ${this.typeOf}`,
      }
    },
  },
  async mounted() {
    this.showWaitAboveAll();
    await this.populateState();
    if (!this.isAdd) {
      await this.get();
    }
    this.hideWaitAboveAll();
  },
  computed: {
    mayIsee() {
      return this.mayI('client-add', 'client-viewer');
    },
    typeOf() {
      return this.isAdd ? "Adicionar" : "Alterar";
    },
    isAdd() {
      return this.id == '' || this.id == null || this.id == undefined;
    },
    receivesInfo: {
      get() {
        return this.form.in_recebe_info === "S";
      },
      set(value) {
        this.form.in_recebe_info = value ? "S" : "N";
      }
    },
    receivesSms: {
      get() {
        return this.form.in_recebe_sms === "S";
      },
      set(value) {
        this.form.in_recebe_sms = value ? "S" : "N";
      }
    },
    agreesToTerms: {
      get() {
        return this.form.in_concorda_termos === "S";
      },
      set(value) {
        this.form.in_concorda_termos = value ? "S" : "N";
      }
    },
    is_disabled: {
      get() {
        return this.form.is_disabled === "S";
      },
      set(value) {
        this.form.is_disabled = value ? "S" : null;
      }
    }
  },
  methods: {
    async populateState() {
      this.selects.state = await stateService.select()
    },
    save() {
      if (this.processing) return;

      this.processing = true;
      this.$wait.start("inprocessSave");
      this.showWaitAboveAll();

      clientService.save(
          this.getLoggedId(),
          this.isAdd ? '' : this.id,
          this.form.email,
          this.form.ddd_celular,
          this.form.celular,
          this.form.in_recebe_info,
          this.form.in_recebe_sms,
          this.form.in_concorda_termos,
          this.form.ds_nome,
          this.form.ds_sobrenome,
          this.form.dt_nascimento,
          this.form.ds_ddd_telefone,
          this.form.ds_telefone,
          this.form.cd_rg,
          this.form.cd_cpf,
          this.form.ds_endereco,
          this.form.ds_compl_endereco,
          this.form.ds_bairro,
          this.form.ds_cidade,
          this.form.cd_cep,
          this.form.id_estado,
          this.form.in_sexo,
          this.form.nr_endereco,
          this.form.is_disabled
      ).then(
          response => {
              this.processing = false;
              this.hideWaitAboveAll();
              this.$wait.end("inprocessSave");

              if (this.validateJSON(response)) {
                  if (response.success) {
                      this.toastSuccess("Salvo com sucesso");
                      this.$router.push(`/search/clients`);
                  } else {
                      this.toastError(response.msg);
                  }
              }
          },
          error => {
              this.processing = false;
              this.hideWaitAboveAll();
              this.$wait.end("inprocessSave");
              this.toastError("Falha na execução.");
          }
      );
    },
    get() {
      if (this.processing) return;

      this.processing = true;

      this.$wait.start("inprocess");
      this.showWaitAboveAll();
      clientService.get(this.id).then(
        response => {
          this.processing = false;
          this.hideWaitAboveAll();
          this.$wait.end("inprocess");

          if (this.validateJSON(response))
          {
              this.form.loaded = true;
              this.form.email = response.email;
              this.form.ddd_celular = response.ddd_celular;
              this.form.celular = response.celular;
              this.form.ds_nome = response.ds_nome;
              this.form.ds_sobrenome = response.ds_sobrenome;
              this.form.dt_nascimento = response.dt_nascimento;
              this.form.ds_ddd_telefone = response.ds_ddd_telefone;
              this.form.ds_telefone = response.ds_telefone;
              this.form.cd_rg = response.cd_rg;
              this.form.is_disabled	= response.is_disabled;
              this.form.cd_cpf = response.cd_cpf;
              this.form.ds_endereco = response.ds_endereco;
              this.form.ds_compl_endereco = response.ds_compl_endereco;
              this.form.ds_bairro = response.ds_bairro;
              this.form.ds_cidade = response.ds_cidade;
              this.form.cd_cep = response.cd_cep;
              this.form.in_recebe_info = response.in_recebe_info;
              this.form.in_recebe_sms = response.in_recebe_sms;
              this.form.in_concorda_termos = response.in_concorda_termos;
              this.form.id_estado = response.id_estado;
              this.form.in_sexo = response.in_sexo;
              this.form.nr_endereco = response.nr_endereco;
          }
        },
        error => {
          this.processing = false;
          this.hideWaitAboveAll();
          this.$wait.end("inprocess");
          this.toastError("Falha na execução.");
        }
      );      
    }
  },
  data () {
    return {
        processing: false,
        loading: false,
        selects: {
          state: [],
        },
        form: {
          email: '',
          ddd_celular: '',
          celular: '',
          ds_nome: '',
          ds_sobrenome: '',
          dt_nascimento: '',
          ds_ddd_telefone: '',
          ds_telefone: '',
          cd_rg: '',
          is_disabled	: '',
          cd_cpf: '',
          ds_endereco: '',
          ds_compl_endereco: '',
          ds_bairro: '',
          ds_cidade: '',
          cd_cep: '',
          in_recebe_info: '',
          in_recebe_sms: '',
          in_concorda_termos: '',
          id_estado: '',
          in_sexo: '',
          nr_endereco: ''
        }
    }
  }
}
</script>

<style>
.Password {
    max-width: 400px;
    margin: 0 0 !important;
}
</style>
